import React from 'react';
import { Box } from '@mui/material';

// TEMP POC: Gibson-branded loading indicator (pulsing logo) used while Oracle images are fetching,
// in place of the generic MUI CircularProgress spinner. Safe to remove/revert.
const GIBSON_LOGO_URL = '//gibsonhomewares.com/cdn/shop/files/GibsonHomewares_Logo_140x@2x.png';

const GibsonLoadingLogo = ({ size = 40 }) => (
  <Box
    component="img"
    src={GIBSON_LOGO_URL}
    alt="Loading"
    sx={{
      width: size,
      height: 'auto',
      animation: 'gibson-pulse 1.4s ease-in-out infinite',
      '@keyframes gibson-pulse': {
        '0%, 100%': { opacity: 0.25 },
        '50%': { opacity: 1 },
      },
    }}
  />
);

export default GibsonLoadingLogo;
